import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { FormControlName } from './contact-form-types';

@Injectable({
  providedIn: 'root',
})
export class ContactFormService {
  form: FormGroup;
  disabledInputs: { [props: string]: BehaviorSubject<boolean> } = {};

  constructor(private fb: FormBuilder) {
    this.setupFormGroup();
    this.formStateController();
  }

  private setupFormGroup() {
    const formsControls = {};
    // tslint:disable-next-line: forin
    for (const key in FormControlName) {
      const name = FormControlName[key];
      formsControls[name] = [null, Validators.required];
      this.disabledInputs[name] = new BehaviorSubject<boolean>(true);
    }
    this.form = this.fb.group(formsControls);

    this.disabledInputs[FormControlName.MediaConsumo].next(false);
  }

  private formStateController() {
    this.form
      .get(FormControlName.MediaConsumo)
      .valueChanges.pipe(debounceTime(200))
      .subscribe((value: string) => {
        const control = this.form.get(FormControlName.MediaConsumo);
        if (control.valid) {
          this.disabledInputs[FormControlName.Estado].next(false);
        }
      });

    this.form
      .get(FormControlName.Estado)
      .valueChanges.pipe(debounceTime(200))
      .subscribe((value: string) => {
        const control = this.form.get(FormControlName.Estado);
        if (control.valid) {
          this.disabledInputs[FormControlName.Cidade].next(false);
        }
      });

    this.form
      .get(FormControlName.Cidade)
      .valueChanges.pipe(debounceTime(200))
      .subscribe((value: string) => {
        const control = this.form.get(FormControlName.Cidade);
        if (control.valid) {
          this.disabledInputs[FormControlName.Nome].next(false);
        }
      });

    this.form
      .get(FormControlName.Nome)
      .valueChanges.pipe(debounceTime(200))
      .subscribe((value: string) => {
        const control = this.form.get(FormControlName.Nome);
        if (control.valid) {
          this.disabledInputs[FormControlName.Telefone].next(false);
        }
      });

    this.form
      .get(FormControlName.Telefone)
      .valueChanges.pipe(debounceTime(200))
      .subscribe((value: string) => {
        const control = this.form.get(FormControlName.Telefone);
        if (control.valid) {
          this.disabledInputs[FormControlName.Email].next(false);
        }
      });
  }
}
